import React from 'react';

import HidingElement from '../utils/HidingElement'
import Pixel, {PIXEL_ACTIONS} from '../utils/Pixel'
import {ErrorMessage} from '../utils/ErrorMessages'
import AgreedButton from './AgreedButton'
import PopupFrame from '../../layout/parts/PopupFrame'
import emailRegex from '../../utils/EmailRegex'
import { Edit } from '../utils/Symbols'

var phoneRegex = RegExp(
    "^(8|\\+\\d)"
     + "[\\- ]?"
     + "(\\(?\\d{3}\\)?)"
     + "[\\- ]?"
     + "[\\d\\- ]{7,10}$"
)

class CustomerInfoPopup extends HidingElement {

    constructor (props) {
        super (props)
        this.state = {
            errors: this.props.errors || {},
            name: '',
            email: '',
            phone: '',
        }
    }

    static getDerivedStateFromProps(nextProps, prevState){
        return {errors: {...prevState.errors, ...nextProps.errors}};
    }

    renderIfEnabled () {
        return (
            <PopupFrame
                title="Оформление заказа"
                onClose={this.props.onClose}>

                <Pixel 
                    eventId={this.props.eventId} 
                    performanceId={this.props.performanceId} 
                    action={PIXEL_ACTIONS.OPEN} />
                
                <div className="tickets-popup-head">
                    Заполните форму для получения билетов
                </div>

                <div className="row">
                    <ErrorMessage for='name' errors={this.state.errors} />
                    <input className="u-full-width"
                            id="nameInput"
                            type="text"
                            maxLength="254"
                            placeholder="Имя и Фамилия"
                            title="Ваше имя могут проверить на входе"
                            value={this.state.name}
                            onChange={this.handleNameChange} />
                </div>

                <div className="row">
                    <ErrorMessage for='email' errors={this.state.errors} />
                    <input className="u-full-width"
                            id="emailInput"
                            type="email"
                            maxLength="254"
                            placeholder="E-mail"
                            title="Мы отправим на этот адрес ваши билеты"
                            value={this.state.email}
                            onChange={this.handleEmailChange} />
                </div>

                <div className="row">
                    <ErrorMessage for='phone' errors={this.state.errors} />
                    <input className="u-full-width"
                            id="emailInput"
                            type="text"
                            maxLength="254"
                            placeholder="Номер телефона"
                            title="По этому телефону менеджер может связаться с вами в случае отмены мероприятия или других изменений"
                            value={this.state.phone}
                            onChange={this.handlePhoneChange} />
                </div>

                <a className="tickets-popup-edit-link mobile-only"
                        href='#editOrder' 
                        onClick={this.props.back}>
                    <Edit />
                    Изменить заказ
                </a>

                <div className="tickets-button-block">
                    <AgreedButton
                            onClick={this.handleSubmit}
                            buttonTitle="Вы должны согласиться с условиями приобретения и офертой"
                            onUpdate={this.props.onUpdate}
                            agreed={this.props.policyAgreed}
                            showOffer={this.props.showOffer}
                            showRules={this.props.showRules}
                            buttonText="Далее">
                    </AgreedButton>
                </div>

                <Pixel 
                    eventId={this.props.eventId} 
                    performanceId={this.props.performanceId} 
                    action={PIXEL_ACTIONS.WIDGET_OPEN_USERINFO} />

            </PopupFrame>
        )
    }

    handleEmailChange = event => this.setState({email: event.target.value})
    handleNameChange = event => this.setState({name: event.target.value})
    handlePhoneChange = event => this.setState({phone: event.target.value})

    handleSubmit = (event) => {
        event.preventDefault()
        this.setState({errors: {}})
        const errors = this.checkFields()
        this.setState({errors: errors})

        if (Object.keys(errors).length) return 

        this.props.onUpdate({
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone,
        })

        this.props.next()
    }

    checkFields = () => {
        var errors = {}
        if (!this.state.name) {
            errors.name = "Заполните ваше имя"
        }
        if (!this.state.email) {
            errors.email = "Заполните ваш email"
        }
        if (!this.state.phone) {
            errors.phone = "Заполните номер телефона"
        }
        if (!emailRegex.test(this.state.email.toLowerCase())) {
            errors.email = "Введите корректный email. Пример: ivan@example.com"
        }
        if (!phoneRegex.test(this.state.phone.toLowerCase())) {
            errors.phone = "Введите корректный номер телефона. Пример: +7(987)123-45-67"
        }
        return errors
    }
}

export default CustomerInfoPopup
